$(() => {
    const $appBtn = $('#apply-to-selected-btn');
    const $selectBtn = $('#no-jobs-selected-btn');
    const btnTxt = $appBtn.html();

    // Hide by default until we receive a selection changed event.
    $appBtn.hide();

    $(document).on('job-recommender:list:selection-changed', function (evt) {
        if (evt.detail.selected.length > 0) {
            $appBtn.html(btnTxt);
            $appBtn.attr('disabled', false);
            $appBtn.find('#selected-job-count').text(evt.detail.selected.length);
            $appBtn.show();
            $selectBtn.hide();
        } else {
            $appBtn.hide();
            $appBtn.attr('disabled', true);
            $selectBtn.show();
            $appBtn.find('#selected-job-count').text(evt.detail.selected.length);
        }
    });

    $(document).on('job-recommender:attempting-apply', function () {
        /**
         * Disable so that we can prevent multiple clicks.
         */
        $appBtn.text($appBtn.data('loadingText'));
        $appBtn.attr('disabled', true);
    });

    $(document).on('click', '#apply-to-selected-btn', function (evt) {
        const event = new CustomEvent('job-recommender:apply', { bubbles: true });
        evt.currentTarget.dispatchEvent(event);
    });

    $(document).on('click', '#recommender-no-thanks-btn', function (evt) {
        const event = new CustomEvent('job-recommender:apply-bar:skip', { bubbles: true });
        evt.currentTarget.dispatchEvent(event);
    });
});
